export const SITE_URL = 'https://www.caloriescience.ai';
export const BLOG_AUTHOR_NAME = 'Vandana Pramod';

export type BlogSeoMetadata = {
  slug: string;
  href: string;
  category: string;
  publishedDate: string;
  displayDate: string;
  title: string;
  metaTitle: string;
  metaDescription: string;
  primaryKeyword: string;
  secondaryKeywords: string[];
  imagePath: string;
  /** Absolute-path JPG/PNG for Open Graph and Twitter (1200×630). */
  ogImagePath: string;
  imageAlt?: string;
  authorName?: string;
};

const publishedDate = '2026-06-04';
const displayDate = '4 JUN 2026';

export const blogSeoMetadata: BlogSeoMetadata[] = [
  {
    slug: 'how-to-price-a-nutrition-consultation-uk',
    href: '/blog/how-to-price-a-nutrition-consultation-uk',
    category: 'Practice Operations',
    publishedDate: '2026-09-17',
    displayDate: '17 SEP 2026',
    title: 'How to Price a Nutrition Consultation in the UK: A Practical Worksheet',
    metaTitle: 'How to Price a Nutrition Consultation UK | CalorieScience',
    metaDescription:
      'Work out UK nutrition consultation fees from scope, time, costs and capacity, with labelled GBP examples.',
    primaryKeyword: 'how to price a nutrition consultation UK',
    secondaryKeywords: ['nutritionist consultation pricing', 'nutrition practice costs'],
    imagePath: '/images/marketing/landing-blog-1.webp',
    ogImagePath: '/images/marketing/og-blog-1.jpg',
    imageAlt: 'Food and meal-planning materials for a nutrition consultation',
    authorName: 'CalorieScience',
  },
  {
    slug: 'client-management-platforms-for-nutritionists',
    href: '/blog/client-management-platforms-for-nutritionists',
    category: 'Practice Operations',
    publishedDate: '2026-07-25',
    displayDate: '25 JUL 2026',
    title:
      'Client Management Platforms for Nutritionists: How to Choose One for a Modern Practice (2026)',
    metaTitle: 'Client Management for Nutritionists | CalorieScience',
    metaDescription:
      'Compare client management platforms for nutritionists and why all-in-one AI software fits modern practices.',
    primaryKeyword: 'client management platforms for nutritionists',
    secondaryKeywords: [
      'platform for modern nutrition practices',
      'nutrition practice management software',
      'dietitian client management software',
      'nutrition CRM',
      'all-in-one nutrition software',
      'AI-assisted nutrition platform',
    ],
    imagePath: '/images/marketing/landing-blog-2.webp',
    ogImagePath: '/images/marketing/og-blog-2.jpg',
    imageAlt:
      'Nutrition practitioner reviewing client records, meal plans and follow-ups in a modern practice platform.',
  },
  {
    slug: 'how-to-get-clients-as-a-nutritionist-uk',
    href: '/blog/how-to-get-clients-as-a-nutritionist-uk',
    category: 'Practice Growth',
    publishedDate,
    displayDate,
    title: 'How to Get More Clients as a Nutritionist in the UK — The 11-Part Growth System (2026)',
    metaTitle: 'Get More Clients as a Nutritionist UK | CalorieScience',
    metaDescription:
      'Eleven proven ways UK nutritionists get more clients—from local SEO and referrals to AI practice software.',
    primaryKeyword: 'how to get clients as a nutritionist UK',
    secondaryKeywords: [
      'grow nutrition practice UK',
      'client retention nutrition practice',
      'nutrition practice management software UK',
      'AI nutrition software UK',
      'nutrition software for professionals',
      'nutritionist business growth UK',
    ],
    imagePath: '/images/marketing/landing-blog-1.webp',
    ogImagePath: '/images/marketing/og-blog-1.jpg',
    imageAlt:
      'UK nutritionist reviewing client meal plans inside the CalorieScience practice platform — desktop view.',
  },
  {
    slug: 'best-clinical-nutrition-platforms-uk-healthcare-practitioners',
    href: '/blog/best-clinical-nutrition-platforms-uk-healthcare-practitioners',
    category: 'Clinical Nutrition Software',
    publishedDate,
    displayDate,
    title:
      'Best Clinical Nutrition Platforms for Healthcare Practitioners in the UK (2026): Top 7 Ranked by Features, Clinical Depth and Time Saved',
    metaTitle: 'Clinical Nutrition Platforms UK | CalorieScience',
    metaDescription:
      'Top clinical nutrition platforms for UK practitioners, ranked by features, clinical depth and time saved.',
    primaryKeyword: 'best clinical nutrition platform UK',
    secondaryKeywords: [
      'clinical nutrition software',
      'nutritionist platform',
      'nutrition analysis software for dietitians',
      'AI-assisted platform for nutrition practitioners',
    ],
    imagePath: '/images/marketing/landing-blog-2.webp',
    ogImagePath: '/images/marketing/og-blog-2.jpg',
  },
  {
    slug: 'ai-assisted-nutrition-platform-professionals-uk',
    href: '/blog/ai-assisted-nutrition-platform-professionals-uk',
    category: 'AI and Automation',
    publishedDate,
    displayDate,
    title:
      'AI-Assisted Nutrition Platform for Professionals: How UK Nutritionists Are Using AI to Serve More Clients in Less Time (2026)',
    metaTitle: 'AI Nutrition Platform for UK Professionals | CalorieScience',
    metaDescription:
      'How UK nutritionists use AI platforms to automate meal planning, cut admin and grow without longer hours.',
    primaryKeyword: 'AI-assisted nutrition platform for professionals',
    secondaryKeywords: [
      'AI meal planning software for nutritionists',
      'nutrition practice management software UK',
      'personalised nutrition software UK',
      'automated meal planning for dietitians',
    ],
    imagePath: '/images/marketing/landing-blog-3.webp',
    ogImagePath: '/images/marketing/og-blog-3.jpg',
  },
];

export const blogSeoMetadataBySlug = blogSeoMetadata.reduce<Record<string, BlogSeoMetadata>>(
  (postsBySlug, post) => {
    postsBySlug[post.slug] = post;
    return postsBySlug;
  },
  {}
);

export const getAbsoluteSiteUrl = (path: string) => {
  if (path.startsWith('http')) return path;
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};
